import React, { useEffect, useState } from 'react';

export default function Preloader() {
  const [done, setDone] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setDone(true), 1300);
    const t2 = setTimeout(() => setHidden(true), 1900);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (hidden) return null;

  return (
    <div className={`preloader${done ? ' preloader--done' : ''}`}>
      <div className="preloader__ringwrap">
        <svg className="preloader__ring" viewBox="0 0 120 120" width="250" height="250" aria-hidden="true">
          <circle cx="60" cy="60" r="54" />
        </svg>
        <picture>
          <source srcSet="/logo.webp" type="image/webp" />
          <img src="/logo.png" alt="" className="preloader__logo" />
        </picture>
      </div>
    </div>
  );
}
